import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'How to Ship Golf Clubs | ShipSticks',
  description: 'How to book, pack, and label your golf clubs for shipping ahead with ShipSticks.',
  alternates: {
    canonical: 'https://www.shipsticks.com/how-it-works',
  },
}

export default metadata
